import { ReactNode } from 'react';

import { Delete, Deselect } from '@mui/icons-material';
import { IconButton, Stack, Typography } from '@mui/material';

type BulkSelectionActionsProps = {
	selectedCount: number;
	onClearSelection: () => void;
	onDeleteSelected: () => void;
	deleteLabel: string;
	deleteDisabled?: boolean;
	children?: ReactNode;
};

export default function BulkSelectionActions({
	selectedCount,
	onClearSelection,
	onDeleteSelected,
	deleteLabel,
	deleteDisabled,
	children,
}: BulkSelectionActionsProps) {
	return (
		<Stack direction="row" spacing={0.5} alignItems="center" sx={{ flexShrink: 0, justifyContent: 'flex-end' }}>
			<Typography variant="body2" color="text.secondary" sx={{ minWidth: 96, textAlign: 'right' }}>
				{selectedCount} selected
			</Typography>
			<IconButton size="small" aria-label="Clear selection" title="Clear selection" onClick={onClearSelection} disabled={selectedCount === 0}>
				<Deselect fontSize="small" />
			</IconButton>
			{children}
			<IconButton
				size="small"
				color="error"
				aria-label={deleteLabel}
				title={deleteLabel}
				onClick={onDeleteSelected}
				disabled={deleteDisabled || selectedCount === 0}
			>
				<Delete fontSize="small" />
			</IconButton>
		</Stack>
	);
}
